import axiosInstance from "./axiosConfig";
import { handleApiError } from "./errorHandler";

export const prepare_certification_data = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/prepare_certification_data`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'prepare_certification_data');
    }
};

export const topics_completed_in_a_topic_group = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/get_topics_completed_in_a_topic_group`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'topics_completed_in_a_topic_group');
    }
};

export const topics_completed_by_location = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/get_topics_completed_by_location`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'topics_completed_by_location');
    }
};

export const change_in_topic_risk_score = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/get_change_in_topic_risk_score`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'change_in_topic_risk_score');
    }
};

export const topics_completed_and_repeated = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/get_topics_completed_and_repeated`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'topics_completed_and_repeated');
    }
};

export const topics_completed_and_repeated_locations = async (data) => {
    try {
        const response = await axiosInstance.post(`/api/get_topics_completed_and_repeated_locations`, data);
        return response;
    } catch (error) {
        throw handleApiError(error, 'topics_completed_and_repeated_locations');
    }
};
